import get from 'lodash/get';
import reduce from 'lodash/reduce';

import {
  isOrderedContentSection,
  isGridPositionsContentSection 
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import {
  buildInitialSectionOverrides as buildInitialGenericSectionOverrides
} from './generic_section_overrides.js';

import {
  buildInitialSectionOverrides as buildInitialGridPositionsSectionOverrides
} from './grid_section_overrides.js';

import {
  buildInitialSectionOverrides as buildInitialOrderedContentSectionOverrides
} from './ordered_content_section_overrides.js';


export const generateInitialSectionOverridesForSection = (
  section,
  existingSectionOverrides={},
  {
    addTileCreatorForGrid=true,
    shouldMapGridPositionsToEidMask=true,
    shouldMaskOverridesWithPredefinedSection=true
  }={}
) => {
  // every section has generic overrides such as loading state so we build the
  // initial data for all section types
  buildInitialGenericSectionOverrides(section);

  if (isOrderedContentSection(section)) {
    return buildInitialOrderedContentSectionOverrides(section);

  } else if (isGridPositionsContentSection(section)) {
    return buildInitialGridPositionsSectionOverrides(
      section,
      existingSectionOverrides,
      {
        addTileCreator: addTileCreatorForGrid,
        shouldMapGridPositionsToEidMask,
        shouldMaskOverridesWithPredefinedSection,
      }
    );

  } else {
    return {};
  }
};

export const buildInitialSectionOverridesSectionsById = (
  sectionsById,
  sectionOverridesById
) => (
  reduce(sectionsById, (accu, section, sectionId)=> ({
    ...accu,
    [sectionId]: generateInitialSectionOverridesForSection(
      section,
      get(sectionOverridesById, sectionId, {}),
      {
        /**
         * If we're hydrating sections here then we
         * already have the necessary data.
         * 
         * We just have to check if we have any tile
         * creators already, otherwise add a new one. The
         * default is to always try and add a tile creator.
         */
        shouldMaskOverridesWithPredefinedSection: false
      }
    )
  }), {})
);